import {
  BOT_TYPES,
  BOT_TYPE_TO_QUERY_BOT_TYPE,
} from "@shared/common/constants";
import { BotConfigurationType, BotType } from "@shared/types";

export const LOGIN_PATH = "/login";
export const OAUTH_LOGIN_PATH = "/oauth_login";
export const OAUTH_AUTHORIZE_LOGIN_PATH = "/oauth_authorize_login";
export const TELEGRAM_AUTH_PATH = "/telegram_oauth_login";
export const DISCORD_FOLLOW_SIGNAL_PATH = "/signal_details";
export const BASE_REGISTER_PATH = "/register";
export const REGISTER_PATH = BASE_REGISTER_PATH + "/:referralCode?";
export const RESET_PASSWORD_PATH = "/reset-password";
export const REGISTER_VERIFY_EMAIL_PATH = BASE_REGISTER_PATH + "/verify-email";
export const AUTH_PATHS = [
  LOGIN_PATH,
  RESET_PASSWORD_PATH,
  REGISTER_PATH,
  REGISTER_VERIFY_EMAIL_PATH,
];

export const ONBOARDING_VERIFY_EMAIL_PATH =
  BASE_REGISTER_PATH + "/confirm-email";
export const ONBOARDING_CONFIRM_SOCIAL_CODE_PATH =
  BASE_REGISTER_PATH + "/confirm-social";
export const ONBOARDING_SELECT_EXCHANGE_PATH =
  BASE_REGISTER_PATH + "/select-exchange";
export const ONBOARDING_CONNECT_EXCHANGE_PATH =
  BASE_REGISTER_PATH + "/connect-exchange";
export const ONBOARDING_TRADING_METHOD_PATH =
  BASE_REGISTER_PATH + "/trading-method";
export const ONBOARDING_FOLLOW_SIGNALS_GROUP_PATH =
  BASE_REGISTER_PATH + "/follow-signals-group";
export const ONBOARDING_CONNECT_EXTERNAL_ACCOUNT_PATH =
  BASE_REGISTER_PATH + "/connect-external-account";
export const ONBOARDING_COPY_DCA_BOT_PATH =
  BASE_REGISTER_PATH + "/copy-dca-bot";
export const ONBOARDING_SIGNALS_GROUP_OVERVIEW_PATH =
  BASE_REGISTER_PATH + "/signals-group-overview";
export const ONBOARDING_DCA_BOT_OVERVIEW_PATH =
  BASE_REGISTER_PATH + "/dca-bot-overview";

export const ONBOARDING_PATHS = [
  ONBOARDING_VERIFY_EMAIL_PATH,
  ONBOARDING_CONFIRM_SOCIAL_CODE_PATH,
  ONBOARDING_SELECT_EXCHANGE_PATH,
  ONBOARDING_CONNECT_EXCHANGE_PATH,
  ONBOARDING_TRADING_METHOD_PATH,
  ONBOARDING_FOLLOW_SIGNALS_GROUP_PATH,
  ONBOARDING_CONNECT_EXTERNAL_ACCOUNT_PATH,
  ONBOARDING_COPY_DCA_BOT_PATH,
  ONBOARDING_SIGNALS_GROUP_OVERVIEW_PATH,
  ONBOARDING_DCA_BOT_OVERVIEW_PATH,
];

export const QUICK_ONBOARDING_SUFFIX = "/quick-onboarding";
export const QUICK_ONBOARDING_PATH = "*" + QUICK_ONBOARDING_SUFFIX;

export const CONNECT_TELEGRAM_PATH = "/connect-telegram";
export const VALIDATE_TELEGRAM_PATH = "/validate-connect-telegram";

export const ADMIN_PATH = "/admin";
export const BASE_GROUP_MANAGEMENT_PATH = ADMIN_PATH + "/group-management";
export const GROUP_MANAGEMENT_PATH = BASE_GROUP_MANAGEMENT_PATH + "/:tab?";
export const ADMIN_SIGNALS_PATH = ADMIN_PATH + "/signals";
export const ADMIN_TRADING_CONFIGURATION_PATH =
  ADMIN_PATH + "/trading-configuration";

export const PORTFOLIO_PATH = "/portfolio";
export const PORTFOLIO_TABS_PATH =
  PORTFOLIO_PATH + "/:tab(assets|positions|accounts)";
export const PORTFOLIO_ASSETS_PATH = PORTFOLIO_PATH + "/assets";
export const PORTFOLIO_POSITIONS_PATH = PORTFOLIO_PATH + "/positions";
export const PORTFOLIO_ACCOUNTS_PATH = PORTFOLIO_PATH + "/accounts";
export const BASE_TRADES_PATH = "/trades";
export const TRADES_PATH = BASE_TRADES_PATH + "/:tab?";
export const OPEN_TRADES_PATH = BASE_TRADES_PATH + "/open";
export const CLOSED_TRADES_PATH = BASE_TRADES_PATH + "/closed";
export const CREATE_TRADE_PATH = "/trading-terminal";
export const CREATE_SIGNAL_PATH = "/signal-terminal";
export const WATCHLIST_PATH = "/watchlist";
export const DASHBOARD_PATH = "/dashboard";
export const MCP_PATH = "/mcp";
export const FINANCE_PATH = "/finance";
export const BOTS_PATH = "/bots";
const botTypesQueryStrings = BOT_TYPES.map(
  (botType) => BOT_TYPE_TO_QUERY_BOT_TYPE[botType]
).join("|");
export const BASE_BOTS_PATH = BOTS_PATH + `/:botType(${botTypesQueryStrings})`;
export const BASE_BOTS_BACKTESTING_PATH = BASE_BOTS_PATH + "/backtesting";
export const BASE_MY_BOTS_PATH = BASE_BOTS_PATH + "/my-bots";
export const BASE_BOTS_WITH_ACTION_PATH =
  BASE_BOTS_PATH + "/:action(edit|duplicate|create|bulk_create)?/:botId(\\d+)?";
export const BASE_BOT_FORM_PATH =
  BASE_BOTS_PATH + "/:action(edit|duplicate|create|bulk_create)/:botId(\\d+)?";
export const ADMIN_TRADING_CONFIGURATION_FORM_PATH =
  ADMIN_TRADING_CONFIGURATION_PATH +
  `/:configurationType(${BotConfigurationType.LEVERAGE}|${BotConfigurationType.SPOT})`;
export const TRADING_VIEW_BOT_PATH =
  BOTS_PATH + `/${BOT_TYPE_TO_QUERY_BOT_TYPE[BotType.TRADING_VIEW]}`;
export const TRADING_VIEW_SIGNALS_PATH =
  BOTS_PATH + `/${BOT_TYPE_TO_QUERY_BOT_TYPE[BotType.TRADING_VIEW_SIGNALS]}`;
export const SIGNALS_BOT_PATH =
  BOTS_PATH + `/${BOT_TYPE_TO_QUERY_BOT_TYPE[BotType.SIGNAL]}`;
export const GRID_BOT_PATH =
  BOTS_PATH + `/${BOT_TYPE_TO_QUERY_BOT_TYPE[BotType.GRID]}`;
export const HEDGING_BOT_PATH =
  BOTS_PATH + `/${BOT_TYPE_TO_QUERY_BOT_TYPE[BotType.HEDGING]}`;
export const BASE_DCA_BOTS_PATH =
  BOTS_PATH + `/${BOT_TYPE_TO_QUERY_BOT_TYPE[BotType.ASAP]}`;
export const BASE_PUBLIC_BOT_PATH = BASE_BOTS_PATH + "/public/:botUUID";
export const DCA_PUBLIC_BOTS_PATH = BASE_DCA_BOTS_PATH + "/public-bots";
export const BASE_PUBLIC_EDIT_BOT_PATH =
  BASE_BOTS_PATH + "/public/edit/:botUUID";
export const AFFILIATION_PATH = "/affiliation/:tab?";
export const WHOP_LANDING_PATH = "/whop-landing";
export const CONNECT_WHOP_CHANNEL_PATH = "/connect-whop-channel";
export const WHOP_CHANNEL_ERROR_PATH = "/whop-channel-error";

export const UNIVERSAL_LINKS_PATHS = ["/cornix_registration", "/cornix_login"];
export const BASE_BOTS_SIGNALS_PATH = BASE_BOTS_PATH + "/user-signals";
export const USER_SIGNALS_PATH = "/signals";
export const MARKETPLACE_PATH = "/marketplace";
export const USERS_MANAGEMENT_PATH = "/users-management";
export const GROUP_CONFIGURATION_SUFFIX =
  "/group-configuration-details/:subGroupId(\\d+)";
export const GROUP_CONFIGURATION_PATH = "*" + GROUP_CONFIGURATION_SUFFIX;
export const MARKETPLACE_GROUP_SUFFIX =
  "/group-details/:subGroupId(\\d+)/:tab?";
export const MARKETPLACE_GROUP_PATH = "*" + MARKETPLACE_GROUP_SUFFIX;
export const CREATE_ACCOUNT_PATH = PORTFOLIO_ACCOUNTS_PATH + "/create-account";

export const SETTINGS_PATH = "/settings";
export const SECURITY_SETTINGS_PATH = SETTINGS_PATH + "/security";
export const NOTIFICATIONS_SETTINGS_PATH =
  SETTINGS_PATH + "/notifications-settings";
export const CHANGE_PASSWORD_SETTINGS_PATH =
  SECURITY_SETTINGS_PATH + "/change-pass";
export const CHANGE_NAME_SETTINGS_PATH =
  SECURITY_SETTINGS_PATH + "/change-name";
export const CONNECT_EMAIL_SETTINGS_PATH =
  SECURITY_SETTINGS_PATH + "/connect-email";

export const INVOICES_PATH = "/invoices";
export const BUSINESS_PROFILE_PATH = "/business-profile";
export const BASE_BILLING_SETTINGS_PATH = SETTINGS_PATH + "/billing";
export const BILLING_SETTINGS_PATH = SETTINGS_PATH + "/billing/:tab?";
export const BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + "/purchase";
export const PURCHASE_SUBSCRIPTION_SETTINGS_PATH =
  BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH + "/:subGroupId(\\d+)?";
export const PURCHASE_API_SLOTS_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + "/purchase-api-slots";
export const BASE_FAILED_AGREEMENT_PATH = "/failed-agreement";
export const BASE_CANCELLED_AGREEMENT_PATH = "/cancelled-agreement";
export const BASE_PROCESSED_AGREEMENT_PATH = "/processed-agreement";
export const BASE_PAID_AGREEMENT_PATH = "/paid-agreement";
export const PROCESSED_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_PROCESSED_AGREEMENT_PATH;
export const PAID_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_PAID_AGREEMENT_PATH;
export const FAILED_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_FAILED_AGREEMENT_PATH;
export const CANCELLED_AGREEMENT_SETTINGS_PATH =
  BASE_BILLING_SETTINGS_PATH + BASE_CANCELLED_AGREEMENT_PATH;
export const CONFIGURATION_TWO_FA_PATH =
  SECURITY_SETTINGS_PATH + "/two-factor-auth";
export const CONFIGURATION_DISABLE_TWO_FA_PATH =
  SECURITY_SETTINGS_PATH + "/disable-two-factor-auth";
export const COIN_EXTRA_DETAILS_SUFFIX = "/coin-details/:coin/:tab?";
export const COIN_EXTRA_DETAILS_PATH = "*" + COIN_EXTRA_DETAILS_SUFFIX;
export const ACCOUNT_EXTRA_DETAILS_SUFFIX =
  "/account-details/:accountId(\\d+)/:tab?";
export const ACCOUNT_EXTRA_DETAILS_PATH = "*" + ACCOUNT_EXTRA_DETAILS_SUFFIX;
export const TRADE_EXTRA_DETAILS_SUFFIX =
  "/trade-details/:tradeId(\\d+)/:tab?/:edit?";
export const BOT_EXTRA_DETAILS_SUFFIX = "/bot-details/:botId(\\d+)/:tab?";
export const BOT_EXTRA_DETAILS_PATH = "*" + BOT_EXTRA_DETAILS_SUFFIX;
export const TRADE_EXTRA_DETAILS_PATH = "*" + TRADE_EXTRA_DETAILS_SUFFIX;
export const BACKTESTING_EXTRA_DETAILS_SUFFIX =
  "/backtesting-details/:botId(\\d+)/:tab?";
export const BACKTESTING_EXTRA_DETAILS_PATH =
  "*" + BACKTESTING_EXTRA_DETAILS_SUFFIX;
export const SIGNAL_EXTRA_DETAILS_SUFFIX =
  "/signal-details/:signalId(\\d+)/:tab/:edit?";
export const SIGNAL_EXTRA_DETAILS_PATH = "*" + SIGNAL_EXTRA_DETAILS_SUFFIX;
export const MY_GROUPS_PATH = "/my-groups";
export const EXTERNAL_INVITE_PATH = "/external-invite";
export const EXTERNAL_INVITE_CONFIRM_USER_PATH =
  EXTERNAL_INVITE_PATH + "/confirm-user";
export const EXTERNAL_INVITE_SUCCESS_PATH = EXTERNAL_INVITE_PATH + "/success";
export const CANCEL_SUBSCRIPTION_PATH =
  BASE_BILLING_SETTINGS_PATH + "/cancel-subscription";

export const EXTERNAL_ACCOUNT_CONFIGURATION_PATH =
  "/account-configuration/:accountId(\\d+)/:tab?";

export const WHOP_EXPERIENCE_DEFAULT_PATH = "/whop/experience";

export const TELEGRAM_DISCONNECT_CONFIRMED_PATH =
  "/telegram-disconnected-confirmed";
export const DISCORD_DISCONNECT_CONFIRMED_PATH =
  "/discord-disconnected-confirmed";

export const HIDE_GROUP_SELECT_PATHS = [
  MY_GROUPS_PATH,
  SETTINGS_PATH,
  CONNECT_WHOP_CHANNEL_PATH,
  SECURITY_SETTINGS_PATH,
];
